/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubjectProperty } from './SubjectProperty';
import {
    SubjectPropertyFromJSON,
    SubjectPropertyFromJSONTyped,
    SubjectPropertyToJSON,
    SubjectPropertyToJSONTyped,
} from './SubjectProperty';
import type { CMA } from './CMA';
import {
    CMAFromJSON,
    CMAFromJSONTyped,
    CMAToJSON,
    CMAToJSONTyped,
} from './CMA';

/**
 * 
 * @export
 * @interface PatchCMARequestDto
 */
export interface PatchCMARequestDto {
    /**
     * 
     * @type {SubjectProperty}
     * @memberof PatchCMARequestDto
     */
    subjectProperty?: SubjectProperty;
    /**
     * 
     * @type {CMA}
     * @memberof PatchCMARequestDto
     */
    root?: CMA;
}

/**
 * Check if a given object implements the PatchCMARequestDto interface.
 */
export function instanceOfPatchCMARequestDto(value: object): value is PatchCMARequestDto {
    return true;
}

export function PatchCMARequestDtoFromJSON(json: any): PatchCMARequestDto {
    return PatchCMARequestDtoFromJSONTyped(json, false);
}

export function PatchCMARequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchCMARequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subjectProperty': json['subjectProperty'] == null ? undefined : SubjectPropertyFromJSON(json['subjectProperty']),
        'root': json['root'] == null ? undefined : CMAFromJSON(json['root']),
    };
}

export function PatchCMARequestDtoToJSON(json: any): PatchCMARequestDto {
    return PatchCMARequestDtoToJSONTyped(json, false);
}

export function PatchCMARequestDtoToJSONTyped(value?: PatchCMARequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subjectProperty': SubjectPropertyToJSON(value['subjectProperty']),
        'root': CMAToJSON(value['root']),
    };
}

